import { DataSelect, DataSelectInheritedProps } from 'components/selects/DataSelect';
import useHrTermTypeOptions from 'components/selects/hr/use-hr-term-type-options';

interface HrTermTypeSelectProps extends DataSelectInheritedProps {
  includeArchived?: boolean;
}

/** Authoritative term-type selector scoped by PHP to the actor's accessible organizations. */
export default function HrTermTypeSelect({ includeArchived = true, ...props }: HrTermTypeSelectProps) {
  const fetchTermTypes = useHrTermTypeOptions(includeArchived);

  return <DataSelect action={fetchTermTypes} valueProp="value" labelProp="label" {...props} />;
}
